import { Link } from "react-router-dom";

import type { PublicDirectoryTournament } from "../../../lib/api";
import { sportLabel } from "../../../lib/labels";
import { formatDirectoryDates } from "../../../lib/publicDirectory";
import { NOMBRES_DE_PRUEBA, PRUEBA_MINIMA } from "../content";
import { useTournamentDirectory } from "../useTournamentDirectory";
import "./LiveProof.css";

/** Máximo de tarjetas en la prueba en vivo. */
const MAX_CARDS = 3;

/**
 * Torneos que sirven como prueba en vivo: solo con el directorio ya cargado,
 * sin nombres de prueba (ni en el torneo ni en el organizador) y solo si
 * quedan `PRUEBA_MINIMA` o más. `null` = la sección no se muestra.
 */
export function liveProofTournaments(
  tournaments: PublicDirectoryTournament[],
  status: "loading" | "ready" | "error",
): PublicDirectoryTournament[] | null {
  if (status !== "ready") return null;
  const real = tournaments.filter(
    (tournament) =>
      !NOMBRES_DE_PRUEBA.test(tournament.name ?? "") && !NOMBRES_DE_PRUEBA.test(tournament.organizer_name ?? ""),
  );
  return real.length >= PRUEBA_MINIMA ? real : null;
}

/** Prueba en vivo (#en-vivo): cuántos torneos tienen hoy inscripciones
 * abiertas en Torneos123 y hasta 3 de ellos. Sin logos ni carteles. */
export function LiveProof() {
  const { tournaments, status } = useTournamentDirectory();
  const real = liveProofTournaments(tournaments, status);
  if (!real) return null;
  const shown = real.slice(0, MAX_CARDS);

  return (
    <section id="en-vivo" className="t123-section t123-liveproof" aria-labelledby="t123-liveproof-title">
      <div className="t123-shell t123-liveproof__grid">
        <div className="t123-liveproof__copy">
          <p className="t123-liveproof__live">
            <span className="t123-liveproof__dot" aria-hidden="true" />
            Ahora mismo
          </p>
          <h2 id="t123-liveproof-title" className="t123-liveproof__title">
            Hoy hay <strong>{real.length} torneos</strong> con inscripciones abiertas en Torneos123.
          </h2>
          <Link className="t123-link-arrow t123-liveproof__link" to="/torneos">
            Verlos
          </Link>
        </div>

        <ul className="t123-liveproof__cards t123-scroll-x">
          {shown.map((tournament) => (
            <li key={tournament.slug} className="t123-liveproof__card">
              <span className="t123-liveproof__badge">Inscripciones abiertas</span>
              <strong className="t123-liveproof__name">{tournament.name}</strong>
              <span className="t123-liveproof__meta">
                {sportLabel(tournament.sport)} · {formatDirectoryDates(tournament.start_date, tournament.end_date)}
              </span>
              {tournament.organizer_name ? (
                <span className="t123-liveproof__org">{tournament.organizer_name}</span>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
